import {
  AIAlert,
  IconMagicSolid,
  InfoBadge,
  InfoBadgeTypes,
  SecondaryButton,
  Space,
  SubText,
  Text,
} from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

export interface IGuidedIntakePromoCardProps {
  analyticsId: string
  title: string
  description: string
  actionLabel: string
  isDisabled?: boolean
  onAction: () => void
}

export const GuidedIntakePromoCard = ({
  analyticsId,
  title,
  description,
  actionLabel,
  isDisabled = false,
  onAction,
}: IGuidedIntakePromoCardProps) => {
  const intl = useProcurifyIntl()

  return (
    <AIAlert analyticsId={analyticsId} icon={null}>
      <Space size='medium' align='start'>
        <Space size='xsmall' align='start'>
          <Space size='small' direction='horizontal' align='center'>
            <Text bold breakWord>
              {title}
            </Text>
            <InfoBadge
              type={InfoBadgeTypes.NEUTRAL}
              size='small'
              text={intl.formatMessage(messages.betaBadge)}
            />
          </Space>
          <SubText>{description}</SubText>
        </Space>
        <SecondaryButton
          analyticsId={`${analyticsId}-action`}
          iconComponent={<IconMagicSolid />}
          disabled={isDisabled}
          onClick={onAction}
        >
          {actionLabel}
        </SecondaryButton>
      </Space>
    </AIAlert>
  )
}
